/**
 * The core hides the trail on the registration route; the DLZ design shows „Domov › Vytvoriť
 * konto“ above the heading (Figma 60260:27827), so nothing is suppressed.
 */
export const BREADCRUMBS_CONFIG = {
  noDisplay: [] as readonly string[],
} as const;
